import { render } from "./Title.vue?vue&type=template&id=cc236d82&scoped=true"
import script from "./Title.vue?vue&type=script&lang=js"
export * from "./Title.vue?vue&type=script&lang=js"

import "./Title.vue?vue&type=style&index=0&id=cc236d82&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-cc236d82"

export default script